import store from 'main/store'
import LocalUserService from 'services/localUserService'
import { getSavedSubsidiary } from 'utils/helpers'

function pickDashboardUserId(raw) {
  if (raw == null) {
    return null
  }
  const n = typeof raw === 'number' ? raw : Number.parseInt(String(raw), 10)
  if (!Number.isFinite(n) || n <= 0) {
    return null
  }
  return n
}

/**
 * Pushes the richest available dashboard auth context into Electron main process.
 * Prefers logged-in (subsidiary + hotel) when context exists; otherwise token-updated.
 */
export function pushElectronDashboardAuthSnapshot({
  sessionId,
  userToken,
  userId,
  dashboardUserId,
  currentUser
} = {}) {
  if (!window?.electron?.postMessage) {
    return
  }

  const userService = new LocalUserService()
  const stored = userService.getCurrentUserInfo()
  const effectiveSessionId = sessionId || stored?.sessionId
  if (!effectiveSessionId) {
    return
  }

  const loginState = store.getState().login
  const saved = getSavedSubsidiary()
  const subsidiaryId =
    loginState.currentHotelId || saved?.subsidiaryId || stored?.subsidiaryId || ''
  const hotelName = loginState.currentHotel || saved?.subsidiaryName || ''
  const effectiveUser = currentUser || stored?.user
  const effectiveUserToken = userToken || stored?.userToken
  const effectiveUserId = userId != null ? userId : stored?.userId
  const dashId = pickDashboardUserId(dashboardUserId ?? stored?.dashboardUserId)
  const isInternalAdmin =
    loginState.actuallyIsInternalAdmin === true || loginState.isInternalAdmin === true

  if (subsidiaryId && effectiveUser && effectiveUserToken) {
    window.electron.postMessage({
      type: 'logged-in',
      data: {
        subsidiaryId: String(subsidiaryId).trim(),
        fullName: effectiveUser.fullName || effectiveUser.name || '',
        spAuth: effectiveSessionId,
        userId: String(effectiveUserId != null ? effectiveUserId : ''),
        ...(dashId != null ? { dashboardUserId: dashId } : {}),
        hotelName,
        userToken: effectiveUserToken,
        isInternalAdmin
      }
    })
    return
  }

  window.electron.postMessage({
    type: 'token-updated',
    data: {
      spAuth: effectiveSessionId,
      ...(effectiveUserToken ? { userToken: effectiveUserToken } : {}),
      ...(dashId != null ? { dashboardUserId: dashId } : {}),
      isInternalAdmin
    }
  })
}
